// TODO: move this into en.json and use this.$t("key") instead this is part of vue vue-i18n, you don't see it in here but it's from cs-design-system

// single source of truth for the table styling that must render identically in the
// TipTap editor, the published page (CEModuleRenderer), the compare/update-preview dialogs, and
// (mirrored manually, since it lives in a separate repo/service) medusa/ce-app-api's
// server/templates/pdf-layout.html. Keep every one of those surfaces in sync with these values.
export const TABLE_STYLE_CONTRACT = {
  BORDER_COLOR: '#777',
  BORDER_WIDTH: '1px',
  CELL_PADDING: '8px',
  HEADER_BACKGROUND_COLOR: '#f2f2f2'
};

/**
 * The narrowest a column may RENDER at, in CSS pixels. Not the editor's drag floor - MIN_COLUMN_WIDTH in
 * BoundedColumnResize.js stays 25px and governs how far an author may drag.
 *
 * A cell spends 18px on padding and borders before a glyph is drawn, and `table-layout: fixed` never
 * lets a column grow to fit, so 25px leaves under one character. 50px leaves about four.
 */
export const MIN_RENDERED_COLUMN_WIDTH = 50;

/**
 * The narrowest container tables must stay readable in - the tablet breakpoint, below which
 * CEModuleRenderer scrolls them instead. With MIN_RENDERED_COLUMN_WIDTH this fixes the smallest SHARE a
 * column may take: 50/1024, about 4.88%. A share keeps the table fitted; a pixel floor would not.
 *
 * Keep in step with the `@media (max-width: 1024px)` query in CEModuleRenderer.vue.
 */
export const TABLE_FIT_REFERENCE_WIDTH = 1024;

/**
 * The printable area of one exported PDF page, in CSS pixels.
 *
 * used by the editor's printable-area toggle, which shows authors the real page width
 * and marks where each page ends.
 *
 * DERIVED VALUES - do not edit in isolation. They change if ce-app-api changes the page format,
 * the margins in `lib/ce-app-api/handlers/modules.js` /
 * `lib/ce-sdk/content-engine/components/ce-modules/index.js`, or the body margin in
 * `server/templates/pdf-layout.html`. Switching the export to A4 would take 793.7px (595pt) as the
 * page box and the same deduction off it.
 */
export const PDF_PAGE_GEOMETRY = {
  contentWidth: 720,
  contentHeight: 916,
  previewPagePadding: 24
};

export const PDF_EXPORT_FONT_HREF =
  'https://fonts.googleapis.com/css?family=Roboto:100,300,400,500,700,900|Material+Icons';

/**
 * The stylesheet applied to exported page HTML.
 *
 * lifted out of `exportPageHTML` so the editor's printable-area preview can apply
 * the identical CSS instead of re-declaring typography that then drifts. Every selector is
 * prefixed with `.readable-content`, so injecting it into the app cannot leak into other UI.
 */
export const READABLE_CONTENT_CSS = `
              .readable-content {
                  /* HTML5 display-role reset for older browsers */
                  font-family: Roboto, "Helvetica Neue", sans-serif;
                  font-size: 1em;
                  color: #555;
                  position: relative;
                  -moz-osx-font-smoothing: grayscale;
                  -webkit-font-smoothing: antialiased !important;
                  -moz-font-smoothing: antialiased !important;
                  text-rendering: optimizelegibility !important;
                  line-height: 1.58;
                  letter-spacing: .003em;
              }

              .readable-content html, .readable-content body, .readable-content div, .readable-content span, .readable-content applet, .readable-content object, .readable-content iframe,
              .readable-content h1, .readable-content h2, .readable-content h3, .readable-content h4, .readable-content h5, .readable-content h6, .readable-content p, .readable-content blockquote, .readable-content pre,
              .readable-content a, .readable-content abbr, .readable-content acronym, .readable-content address, .readable-content big, .readable-content cite, .readable-content code,
              .readable-content del, .readable-content dfn, .readable-content em, .readable-content img, .readable-content ins, .readable-content kbd, .readable-content q, .readable-content s, .readable-content samp,
              .readable-content small, .readable-content strike, .readable-content strong, .readable-content sub, .readable-content sup, .readable-content tt, .readable-content var,
              .readable-content b, .readable-content u, .readable-content i, .readable-content center,
              .readable-content dl, .readable-content dt, .readable-content dd, .readable-content ol, .readable-content ul, .readable-content li,
              .readable-content fieldset, .readable-content form, .readable-content label, .readable-content legend,
              .readable-content table, .readable-content caption, .readable-content tbody, .readable-content tfoot, .readable-content thead, .readable-content tr, .readable-content th, .readable-content td,
              .readable-content article, .readable-content aside, .readable-content canvas, .readable-content details, .readable-content embed,
              .readable-content figure, .readable-content figcaption, .readable-content footer, .readable-content header, .readable-content hgroup,
              .readable-content main, .readable-content menu, .readable-content nav, .readable-content output, .readable-content ruby, .readable-content section, .readable-content summary,
              .readable-content time, .readable-content mark, .readable-content audio, .readable-content video {
                  margin: 0;
                  padding: 0;
                  border: 0;
                  font: inherit;
                  vertical-align: baseline; 
              }
  
              .readable-content article, .readable-content aside, .readable-content details, .readable-content figcaption, .readable-content figure,
              .readable-content footer, .readable-content header, .readable-content hgroup, .readable-content main, .readable-content menu, .readable-content nav, .readable-content section {
                  display: block; 
              }
  
              .readable-content body {
                  line-height: 1; 
              }
  
              .readable-content ul {
                  list-style: none; 
              }
  
              .readable-content blockquote, .readable-content q {
                  quotes: none; 
              }
  
              .readable-content blockquote:before, .readable-content blockquote:after, .readable-content q:before, .readable-content q:after {
                  content: '';
                  content: none;
              }
  
              .readable-content table {
                  border-collapse: collapse;
                  border-spacing: 0; 
              }
  
              .readable-content .page-title, .readable-content h1, .readable-content h2, .readable-content h3, .readable-content h4, .readable-content h5, .readable-content h6 {
                  margin-top: 1.3em;
                  margin-bottom: 1.3em;
                  margin-right: 0;
                  margin-left: 0;
                  font-family: Roboto, "Helvetica Neue", sans-serif;
                  font-weight: 700;
                  color: #222; 
              }
  
              .readable-content h1 {
                  font-size: 1.95em;
              }
  
              .readable-content h2 {
                  font-size: 1.65em;
              }
  
              .readable-content h3 {
                  font-size: 1.3em;
              }
              
              .readable-content h4, .readable-content h5, .readable-content h6 { 
                  font-size: 1.1em;
              }
  
              .readable-content header { 
                  padding-bottom: 1.3em;
                  margin-bottom: 1em; 
              }
  
              .readable-content header h1, .readable-content header h2 {
                  margin: .5em 0; 
              }
  
              .readable-content header.center {
                  text-align: center;
              }
  
              .readable-content header h2 {
                  color: #777;
              }
  
              .readable-content a {
                  color: #555;
                  text-decoration: underline;
              }
  
              .readable-content a:hover {
                  color: #222;
              }
  
              .readable-content mark {
                  color: #555;
                  background-color: rgba(82, 232, 165, 0.3);
              }
  
              .readable-content strong, .readable-content b {
                  font-weight: 700;
              }
  
              .readable-content em, .readable-content i, .readable-content cite, .readable-content blockquote, .readable-content q {
                  font-style: italic;
              }
  
              .readable-content small {
                  font-size: 0.78em;
              }
  
              .readable-content big {
                  font-size: 1.56em;
              }
  
              .readable-content abbr[title], .readable-content acronym[title] {
                  text-decoration: underline dotted;
              }
  
              .readable-content sup {
                  vertical-align: super;
                  font-size: 0.78em;
              }
  
              .readable-content sub {
                  vertical-align: sub;
                  font-size: 0.78em;
              }
  
              .readable-content u {
                  text-decoration: underline;
              }
  
              .readable-content img {
                  max-width: 100%;
                  display: block;
                  margin: 1.3em auto;
              }

              /*
               * Image layout modes, mirroring CEModuleRenderer.vue. Images with no
               * data-layout keep the centered rule above (legacy content). The
               * .readable-content prefix is required: a bare img[data-layout] would
               * tie the rule above on specificity and be decided by source order.
               */
              .readable-content img[data-layout='inline'] {
                  display: inline-block;
                  margin: 0 0.25rem;
                  vertical-align: middle;
              }

              .readable-content img[data-layout='left-wrap'] {
                  display: block;
                  float: left;
                  margin: 0.25rem 1rem 0.5rem 0;
              }

              .readable-content img[data-layout='right-wrap'] {
                  display: block;
                  float: right;
                  margin: 0.25rem 0 0.5rem 1rem;
              }

              .readable-content img[data-layout='left'] {
                  display: block;
                  float: none;
                  margin: 0.5rem auto 0.5rem 0;
              }

              .readable-content img[data-layout='center'] {
                  display: block;
                  float: none;
                  margin: 0.5rem auto;
              }

              .readable-content img[data-layout='right'] {
                  display: block;
                  float: none;
                  margin: 0.5rem 0 0.5rem auto;
              }

              .readable-content img.big {
                  margin-top: 1em;
                  margin-bottom: 1em;
                  margin-right: 0;
                  margin-left: 0;
                  width: 120%;
                  margin-left: -10%;
              }
  
              .readable-content p {
                  margin-top: 1em;
                  margin-bottom: 1em;
                  margin-right: 0;
                  margin-left: 0;
                  line-height: 1.58;
                  color: #555;
                  font-family: Roboto, "Helvetica Neue", sans-serif;
              }
  
              .readable-content blockquote {
                  margin-top: 1em;
                  margin-bottom: 1em;
                  margin-right: 0;
                  margin-left: 0;
                  margin-left: 1em;
                  border-left: 0.325em solid #dddddd;
                  padding-left: 1em;
              }
  
              .readable-content code {
                  background-color: #dddddd;
                  opacity: .9;
                  padding: 0.1625em 0.325em;
                  border-radius: 3px;
              }
  
              .readable-content ul {
                  list-style: disc outside none;
              }
  
              .readable-content li {
                  margin-top: 0.65em;
                  margin-bottom: 0.65em;
                  margin-right: 0;
                  margin-left: 0;
                  margin-left: 1em;
              }
  
              .readable-content dl {
                  margin-top: 1em;
                  margin-bottom: 1em;
                  margin-right: 0;
                  margin-left: 0;
              }
  
              .readable-content dl dt {
                  font-weight: 700;
              }
  
              .readable-content dl dd {
                  margin-left: 1em;
              }
  
              .readable-content dl dt + dd {
                  margin-bottom: 1em;
              }
  
              .readable-content table {
                  text-align: left;
                  border-collapse: collapse;
                  vertical-align: middle;
                  width: 100%;
              }

              .readable-content table[style] {
                  max-width: 100% !important;
                  /* min-width beats max-width in CSS - zero it or an inline min-width still overflows. */
                  min-width: 0 !important;
              }

              .readable-content .pm-table-wrapper {
                  overflow: visible;
              }

              .readable-content .pm-table-wrapper td,
              .readable-content .pm-table-wrapper th {
                  word-break: break-word;
              }

              .readable-content table.differences-table {
                  table-layout: fixed;
              }

              .readable-content table.differences-table > thead > tr > th {
                  width: 50%;
              }

              .readable-content td, .readable-content th {
                  vertical-align: middle;
                  border-width: ${TABLE_STYLE_CONTRACT.BORDER_WIDTH};
                  border-style: solid;
                  border-color: ${TABLE_STYLE_CONTRACT.BORDER_COLOR};
                  padding: ${TABLE_STYLE_CONTRACT.CELL_PADDING};
              }

              .readable-content thead th, .readable-content tbody th {
                  background-color: ${TABLE_STYLE_CONTRACT.HEADER_BACKGROUND_COLOR};
                  font-weight: 700;
              }
  
              .readable-content.no-margin {
                  max-width: none;
                  margin: 0;
              }
  
              .readable-content .page-title {
                  font-size: 1.95em;
              }
  
              .readable-content .display-name {
                  font-size: 22px;
                  font-weight: 400;
                  color: #555757;
                  line-height: 32px;
                  letter-spacing: normal;
              }
  
              .readable-content table {
                  border-collapse: collapse;
                  vertical-align: middle;
                  width: 100%;
              }
  
              body {
                  margin: 40 80;
                  font-family: Roboto, "Helvetica Neue", sans-serif;
              }
  
              button {
                  display: none;
              }
  
              .underline {
                  text-decoration: underline;
              }
  
              .readable-content .divHeader, .readable-content .divFooter {
                  width: 100%;
                  color: LightGray;
                  display: block;
                  font-size: 0.90rem;
                  margin-bottom: 1em;
              }
  
              .readable-content .divHeader::after, .readable-content .divFooter::after {
                  margin-top: 1em;
              }
  
              .readable-content .divHeader::after, .readable-content .divFooter::before {
                  content: '';
                  position: absolute;
                  width: 100%;
                  height: 1px;
                  background: LightGray;
              }
  
              .readable-content .divFooter {
                  margin-bottom: 3em;
              }
  
              .readable-content div.header-space {
                  height: 0em;
              }
  
              .readable-content table.page-table > thead > tr > td,
              .readable-content table.page-table > tbody > tr > td,
              .readable-content table.page-table > tfoot > tr > td {
                  border: 0;
              }
  
              .readable-content .logo-top {
                  max-width: 250px !important;
                  max-height: 250px !important;
                  display: block;
              }

              .readable-content .tooltip .tooltip-text {
                display: none;
              }
  
              .readable-content .vdd-added {
                background-color: #c8e6c9;
                text-decoration: none;
              }
              
              .readable-content .vdd-removed {
                background-color: #ffcdd2;
                text-decoration: none;
              }
              
              .readable-content .vdd-modified {
                background-color: #ffecb3;
                text-decoration: none;
              }

              .readable-content .updates-key {
                border: 1px solid #C8CCD1;
                border-radius: 5px;
                margin-bottom: 1.5rem;
                padding: 1.25rem;
              }

              .readable-content .updates-key ul {
                list-style-type: none;
                padding-left: 0 !important;
              }

              .readable-content .added-page-color {
                color: #c8e6c9;
              }

              .readable-content .deleted-page-color {
                color: #ffcdd2;
              }

              .readable-content .modified-page-color {
                color: #ffecb3;
              }

              .readable-content .v-icon {
                align-items: center;
                display: inline-flex;
                -webkit-font-feature-settings: "liga";
                font-feature-settings: "liga";
                font-size: 24px;
                justify-content: center;
                letter-spacing: normal;
                line-height: 1;
                position: relative;
                text-indent: 0;
                transition: .3s cubic-bezier(.25,.8,.5,1),visibility 0s;
                vertical-align: middle;
                -webkit-user-select: none;
                -moz-user-select: none;
                -ms-user-select: none;
                user-select: none;
              }

              .readable-content .v-icon:after {
                background-color: currentColor;
                border-radius: 50%;
                content: "";
                display: inline-block;
                height: 100%;
                left: 0;
                opacity: 0;
                pointer-events: none;
                position: absolute;
                top: 0;
                -webkit-transform: scale(1.3);
                transform: scale(1.3);
                width: 100%;
                transition: opacity .2s cubic-bezier(.4,0,.6,1);
              }

              .readable-content .material-icons {
                font-family: 'Material Icons';
                font-weight: normal;
                font-style: normal;
                font-size: 24px;
                display: inline-block;
                line-height: 1;
                text-transform: none;
                letter-spacing: normal;
                word-wrap: normal;
                white-space: nowrap;
                direction: inherit;
                -webkit-font-smoothing: antialiased;
                text-rendering: optimizeLegibility;
                -moz-osx-font-smoothing: grayscale;
                -webkit-font-feature-settings: 'liga';
                font-feature-settings: 'liga';
              }

              .readable-content .v-alert {
                border-radius: 4px;
                display: block;
                font-size: 16px;
                margin-bottom: 16px;
                padding: 16px;
                position: relative;
                transition: .3s cubic-bezier(.25,.8,.5,1);
                color: #ffffff;
            }

            .readable-content .v-alert.info {
                background-color: rgb(3, 155, 229);
                border-color: rgb(3, 155, 229);
            }

            .readable-content .v-alert .v-alert__wrapper {
                align-items: center;
                border-radius: inherit;
                display: flex;
            }

            .readable-content .v-alert .v-alert__wrapper .v-alert__icon {
                margin-right: 16px;
            }

            .readable-content .mt-2 {
                margin-top: 16px;
            }

            .readable-content .placeholder {
                background: rgb(var(--v-theme-warning));
            }
          
            .readable-content .validContext {
              background: rgb(var(--v-theme-black-lighten-5));
                color: rgb(var(--v-theme-black));
                font-weight: bold;
            }

            .readable-content .v-data-footer.content-register--pagination, .readable-content .content-register--action-buttons {
              display: none;
            }

            .readable-content .document-register--action-buttons,
            .readable-content #document-register .v-data-table-footer {
              display: none;
            }

            .readable-content .document-register--table-wrapper {
              overflow: visible !important;
            }

            .readable-content .v-data-table.document-register--page-properties-table
              .v-table__wrapper,
            .readable-content .v-data-table.document-register--page-properties-table
              .v-data-table__wrapper {
              overflow: visible !important;
            }

            .readable-content .v-data-table.document-register--page-properties-table table {
              table-layout: fixed;
              width: 100% !important;
              font-size: 1em !important;
            }

            .readable-content .v-data-table.document-register--page-properties-table th,
            .readable-content .v-data-table.document-register--page-properties-table td {
              width: auto !important;
              max-width: 0 !important;
              min-width: 0 !important;
              word-break: normal;
              overflow-wrap: break-word;
              hyphens: auto;
              white-space: normal !important;
              padding: 4px 6px !important;
              font-size: 1em !important;
              line-height: 1.2 !important;
              vertical-align: top;
            }

            .readable-content .v-data-table.content-register--page-properties-table
              .v-data-table__wrapper
              table {
              table-layout: fixed;
            }

            .readable-content .v-data-table.content-register--page-properties-table
              .v-data-table__wrapper
              table
              tbody
              tr
              td:first-child,
            .readable-content .v-data-table.content-register--page-properties-table
              .v-data-table__wrapper
              table
              tbody
              tr
              td:nth-child(2),
            .readable-content .v-data-table.content-register--page-properties-table
              .v-data-table__wrapper
              table
              tbody
              tr
              td:nth-child(3),
            .readable-content .v-data-table.content-register--page-properties-table
              .v-data-table__wrapper
              table
              tbody
              tr
              td:nth-child(4),
            .readable-content .v-data-table.content-register--page-properties-table
              .v-data-table__wrapper
              table
              tbody
              tr
              td:nth-child(7),
            .readable-content .v-data-table.content-register--page-properties-table
              .v-data-table__wrapper
              table
              tbody
              tr
              td:nth-child(8),
            .readable-content .v-data-table.content-register--page-properties-table
              .v-data-table__wrapper
              table
              tbody
              tr
              td:nth-child(9),
            .readable-content .v-data-table.content-register--page-properties-table
              .v-data-table__wrapper
              table
              tbody
              tr
              td:last-child {
              width: 9% !important;
              word-break: break-word;
            }

            .readable-content .v-data-table.content-register--page-properties-table
              .v-data-table__wrapper
              table
              tbody
              tr
              td:nth-child(5),
            .readable-content .v-data-table.content-register--page-properties-table
              .v-data-table__wrapper
              table
              tbody
              tr
              td:nth-child(6) {
              width: 14% !important;
              word-break: break-word;
            }

              @page {
                size: auto;
                margin: 0mm 10mm 0mm 0mm;
              }
  
              @media print {
                body {
                    -webkit-print-color-adjust: exact;
                    color-adjust: exact; 
                }
  
                table { 
                    page-break-inside: auto;
                    position: relative;
                    z-index: -1;
                }

                thead, tfoot {
                    background-color: white;
                    width: 100%;
                    z-index: 1;
                }

                tbody {
                    z-index: -1;
                }

                tr { 
                    page-break-inside: avoid; 
                    page-break-after: auto;
                }

                img {
                    page-break-before: auto; 
                    page-break-after: auto; 
                    page-break-inside: avoid;
                }
  
                .readable-content img {
                    max-width: 100%;
                    max-height: 500px;
                    display: block;
                    margin: 1.3em auto;
                }

                /* Image layout modes for print — see the screen block above. */
                .readable-content img[data-layout='inline'] {
                    display: inline-block;
                    margin: 0 0.25rem;
                    vertical-align: middle;
                }

                .readable-content img[data-layout='left-wrap'] {
                    display: block;
                    float: left;
                    margin: 0.25rem 1rem 0.5rem 0;
                }

                .readable-content img[data-layout='right-wrap'] {
                    display: block;
                    float: right;
                    margin: 0.25rem 0 0.5rem 1rem;
                }

                .readable-content img[data-layout='left'] {
                    display: block;
                    float: none;
                    margin: 0.5rem auto 0.5rem 0;
                }

                .readable-content img[data-layout='center'] {
                    display: block;
                    float: none;
                    margin: 0.5rem auto;
                }

                .readable-content img[data-layout='right'] {
                    display: block;
                    float: none;
                    margin: 0.5rem 0 0.5rem auto;
                }

                .readable-content td, .readable-content .page-title {
                    padding-top: 0px; 
                    margin-top: 0px;
                }

                .readable-content .divHeader, .readable-content .divFooter {
                    font-size: 0.70rem;
                    line-height: 1;
                }

                .readable-content .divHeader {
                    top: 3em;
                    width: 80%;
                    position: fixed;
                }

                .readable-content .divFooter {
                    margin-bottom: 0em;
                    bottom: 3em;
                    width: 80%;
                    position: fixed;
                }

                .readable-content div.header-space, .readable-content div.footer-space {
                    height: 5em;
                }

                .readable-content div.header-space {
                    top: 0;
                }
    
                .readable-content div.footer-space {
                    bottom: 0;
                }

                .readable-content .vdd-added {
                    background-color: #c8e6c9;
                    text-decoration: none;
                }
                 
                .readable-content .vdd-removed {
                  background-color: #ffcdd2;
                  text-decoration: none;
                }
                
                .readable-content .vdd-modified {
                  background-color: #ffecb3;
                  text-decoration: none;
                }
            
                .readable-content .updates-key {
                  border: 1px solid #C8CCD1;
                  border-radius: 5px;
                  margin-bottom: 1.5rem;
                  padding: 1.25rem;
                } 

                .readable-content .updates-key ul {
                  list-style-type: none;
                  padding-left: 0 !important;
                } 

                .readable-content .added-page-color {
                  color: #c8e6c9;
                } 

                .readable-content .deleted-page-color {
                  color: #ffcdd2;
                }

                .readable-content .modified-page-color {
                  color: #ffecb3;
                }

                .readable-content .v-icon {
                  align-items: center;
                  display: inline-flex;
                  -webkit-font-feature-settings: "liga";
                  font-feature-settings: "liga";
                  font-size: 24px;
                  justify-content: center;
                  letter-spacing: normal;
                  line-height: 1;
                  position: relative;
                  text-indent: 0;
                  transition: .3s cubic-bezier(.25,.8,.5,1),visibility 0s;
                  vertical-align: middle;
                  -webkit-user-select: none;
                  -moz-user-select: none;
                  -ms-user-select: none;
                  user-select: none;
                }

                .readable-content .v-icon:after {
                  background-color: currentColor;
                  border-radius: 50%;
                  content: "";
                  display: inline-block;
                  height: 100%;
                  left: 0;
                  opacity: 0;
                  pointer-events: none;
                  position: absolute;
                  top: 0;
                  -webkit-transform: scale(1.3);
                  transform: scale(1.3);
                  width: 100%;
                  transition: opacity .2s cubic-bezier(.4,0,.6,1);
                }

                .readable-content .material-icons {
                  font-family: 'Material Icons';
                  font-weight: normal;
                  font-style: normal;
                  font-size: 24px;
                  display: inline-block;
                  line-height: 1;
                  text-transform: none;
                  letter-spacing: normal;
                  word-wrap: normal;
                  white-space: nowrap;
                  direction: inherit;
                  -webkit-font-smoothing: antialiased;
                  text-rendering: optimizeLegibility;
                  -moz-osx-font-smoothing: grayscale;
                  -webkit-font-feature-settings: 'liga';
                  font-feature-settings: 'liga';
                }

                .readable-content .v-alert {
                    border-radius: 4px;
                    display: block;
                    font-size: 16px;
                    margin-bottom: 16px;
                    padding: 16px;
                    position: relative;
                    transition: .3s cubic-bezier(.25,.8,.5,1);
                    color: #ffffff;
                }

                .readable-content .v-alert.info {
                    background-color: rgb(3, 155, 229);
                    border-color: rgb(3, 155, 229);
                }

                .readable-content .v-alert .v-alert__wrapper {
                    align-items: center;
                    border-radius: inherit;
                    display: flex;
                }

                .readable-content .v-alert .v-alert__wrapper .v-alert__icon {
                    margin-right: 16px;
                }
    
                .readable-content .mt-2 {
                    margin-top: 16px;
                }

                .readable-content .v-data-footer.content-register--pagination, .readable-content .content-register--action-buttons {
                  display: none;
                }

                .readable-content .document-register--action-buttons,
                .readable-content #document-register .v-data-table-footer {
                  display: none;
                }

                .readable-content .document-register--table-wrapper {
                  overflow: visible !important;
                }

                .readable-content .v-data-table.document-register--page-properties-table
                  .v-table__wrapper,
                .readable-content .v-data-table.document-register--page-properties-table
                  .v-data-table__wrapper {
                  overflow: visible !important;
                }

                .readable-content .v-data-table.document-register--page-properties-table table {
                  table-layout: fixed;
                  width: 100% !important;
                  font-size: 0.65em !important;
                }

                .readable-content .v-data-table.document-register--page-properties-table th,
                .readable-content .v-data-table.document-register--page-properties-table td {
                  width: auto !important;
                  min-width: 0 !important;
                  max-width: 0 !important;
                  word-break: break-word;
                  overflow-wrap: break-word;
                  hyphens: auto;
                  white-space: normal !important;
                  padding: 2px 3px !important;
                  font-size: 0.65em !important;
                  line-height: 1.2 !important;
                  vertical-align: top;
                }

                .readable-content .v-data-table.content-register--page-properties-table
                  .v-data-table__wrapper
                  table {
                  table-layout: fixed;
                }

                .readable-content .v-data-table.content-register--page-properties-table
                  .v-data-table__wrapper
                  table
                  tbody
                  tr
                  td:first-child,
                .readable-content .v-data-table.content-register--page-properties-table
                  .v-data-table__wrapper
                  table
                  tbody
                  tr
                  td:nth-child(2),
                .readable-content .v-data-table.content-register--page-properties-table
                  .v-data-table__wrapper
                  table
                  tbody
                  tr
                  td:nth-child(3),
                .readable-content .v-data-table.content-register--page-properties-table
                  .v-data-table__wrapper
                  table
                  tbody
                  tr
                  td:nth-child(4),
                .readable-content .v-data-table.content-register--page-properties-table
                  .v-data-table__wrapper
                  table
                  tbody
                  tr
                  td:nth-child(7),
                .readable-content .v-data-table.content-register--page-properties-table
                  .v-data-table__wrapper
                  table
                  tbody
                  tr
                  td:nth-child(8),
                .readable-content .v-data-table.content-register--page-properties-table
                  .v-data-table__wrapper
                  table
                  tbody
                  tr
                  td:nth-child(9)
                .readable-content .v-data-table.content-register--page-properties-table
                  .v-data-table__wrapper
                  table
                  tbody
                  tr
                  td:last-child {
                  width: 9% !important;
                  word-break: break-word;
                }

                .readable-content .v-data-table.content-register--page-properties-table
                  .v-data-table__wrapper
                  table
                  tbody
                  tr
                  td:nth-child(5),
                .readable-content .v-data-table.content-register--page-properties-table
                  .v-data-table__wrapper
                  table
                  tbody
                  tr
                  td:nth-child(6) {
                  width: 14% !important;
                  word-break: break-word;
                }
              }
`;

export const PUBLISH_TYPE_NORMAL = 1;

export const PUBLISH_TYPE_SILENT = 2;

export const TOC_VERSION_1 = 1;

export const TOC_VERSION_2 = 2;

export const CE_MODULE_TYPES = {
  TYPE_COMPLISPACE: 1,
  TYPE_CLIENT: 2
};

export const ROLES = {
  CS_ADMIN: 4,
  GROUP_ADMIN: 3,
  CLIENT_ADMIN: 2,
  CLIENT_USER: 1,
  NOT_AUTHENTICATED: 0
};

export const ROLES_DESCRIPTION = {
  CS_ADMIN: 'CompliSpace Administrator',
  GROUP_ADMIN: 'Group Administrator',
  CLIENT_ADMIN: 'Client Administrator',
  CLIENT_USER: 'Client User',
  NOT_AUTHENTICATED: 'Unauthenticated User'
};

export const SITE_TYPES = {
  SINGLE_SCHOOL: 1,
  CHILD_SCHOOL: 2,
  ENTERPRISE_GROUP: 3
};

export const VIEW_TYPES = {
  CLIENT: 1, // Client/User view
  ADMIN_PUBLISH: 2, // Admin view with draftMode off
  ADMIN_DRAFT: 3 // Admin view with drafMode on
};

export const PAGE_TYPES = {
  // 0 is reserved, when the cgc is not determined in page update process, the cgc is set to 0
  DEFAULT_PAGE: 0,
  PARENT_PAGE: 1,
  CLIENT_PAGE: 2
};

export const UPDATE_CMD = {
  DEFAULT: 'default',
  PAGEUP: 'pageUp',
  PAGEDOWN: 'pageDown',
  SEARCH: 'search',
  DATACHANGE: 'dataChanged',
  LOSEFOCUS: 'loseFocus',
  REFRESH: 'refresh',
  SHOWINGERROR: 'showError'
};

export const ADDING_ID_TAGS = {
  HEADERS: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'],
  CUSTOMER_HEADERS: {
    ITALIC: 'em',
    BOLD: 'strong',
    UNDERLINE: 'u'
  }
};

export const CONTEXT_KEYS = {
  ACTIVATE_HEADER: 'ActivateHeader',
  CLIENT_HEADER: 'ClientHeader'
};

export const COMPONENT_STATE = {
  STATE_IDLE: 0,
  STATE_LOADING_DATA: 1,
  STATE_INITIALING: 2,
  STATE_EDITING: 3,
  STATE_READY_FOR_DATA: 4,
  STATE_RECEIVING_DATA: 5,
  STATE_GETTING_FOCUS: 6,
  STATE_GETTING_UPDATE: 7,
  STATE_PUBLISHING: 8
};

export const COMPONENT_MANAGER_TYPE = {
  TYPE_DATA: 'data',
  TYPE_COM_STATE: 'state'
};

export const APP_STATE = {
  STATE_IDLE: 0,
  STATE_EDITING: 1
};

export const ROUTE_NAME = {
  page: 'Page',
  Dashboard: 'Dashboard'
};

export const PAGE_CHANGE_CMD = {
  DEFUALT: 'default',
  UPDATE_DATA: 'update'
};

export const MODULE_UPDATE_TYPE = {
  TYPE_HAS_UNPUBLISH_CONTENT: 'hasUnpublishedDraftContent'
};

export const EVENTBUS_CMD = {
  HARD_REFRESH: 'hardRefresh',
  UPDATE_SIDENAV: 'updateSideNav'
};

export const IMAGE_UPLOAD_STATE = {
  STATE_UPLOADED: 'uploaded',
  STATE_ADDED: 'added',
  STATE_UPLOADED_AGAIN: 'uploadedAgain',
  STATE_REMOVED: 'removed'
};

export const EXPORT_ATTRIBUTE_TYPE = {
  STRING: 'string',
  DATE: 'date',
  OBJECT: 'object',
  NUMBER: 'number'
};

export const EXPORT_FILE_NAME = {
  SUMMARY_CSV: 'Summary_report.csv',
  USER_CSV: 'Summary_user_report.csv',
  COURSE_CSV: 'Summary_course_report.csv',
  AWARD_CSV: 'Summary_award_report.csv',
  ACTIVITY_CSV: 'Activity_report.csv',
  LOGIN_CSV: 'Login_records.csv',
  CONTENT_REGISTER_CSV: 'Content_register.csv',
  DOCUMENT_REGISTER_CSV: 'Document_register.csv'
};

export const REPORT_TAB = {
  SUMMARY: 'summary',
  ACTIVITY: 'activity'
};

export const CLASS_NAME = {
  IMAGE_CLASS_NAME: 'client-private-image',
  ASSURANCE_REPORT_TABLE: 'assurance-report-table',
  HR_CLASS_NAME: 'hr-in-html'
};

export const ATTRIBUTES = {
  DATA_FILENAME_HASH: 'data-filename-hash'
};

export const MESSAGES = {
  INFO: {
    SAVE_WORK: 'Please Save Your Work Regularly.'
  },
  WARNING: {
    AUDIT_SEARCH_RESULTS_CRITERIA:
      'You have reached the end of the audit log search results for the current criteria. Audit log results are limited to 500 records. If you cannot find what you are looking for, please narrow down your search by modifying the search filters.'
  },
  ERROR: {
    NOT_ACCESSIBLE: 'This content is not currently accessible, please contact your administrator.',
    REORDERING_PUBLISH_ERROR:
      'This module has been edited, please refresh and continue with your page reordering.'
  }
};

export const CE_MAIN_BRANCH = 'master';

export const CE_DRAFT_BRANCH = 'draft';

export const FEATURE_TOGGLE_TEXT = [
  { title: 'Audit Log', description: 'Show/hide audit log features' }
];

export const KEEP_MARKDOWN_TAGS = [
  's',
  'u',
  'table',
  'thead',
  'tbody',
  'tfoot',
  'tr',
  'th',
  'td',
  'caption',
  'colgroup',
  'col'
];

export const LINKS = {
  ABOUT_IDEAGEN: 'https://www.ideagen.com/company'
};

export const MIXPANEL_TRACE_PROPERTIES = {
  CS_CLIENT_ID: 'CompliSpace Client IDP',
  CLIENT_ID: 'Client ID',
  UNIVERSAL_CLIENT_ID: 'Universal Client ID',
  CLIENT_NAME: 'Client Display Name',
  APP_NAME: 'App Name',
  TENANT: 'Tenant (Subdomain)',
  USER_ROLE: 'User Role View',
  MODULE_ID: 'Module ID',
  MODULE_OWNER_ID: 'Module Owner ID',
  MODULE_NAME: 'Module Display Name',
  MODULE_CUSTOM_DISPLAY_NAME: 'Module Custom Display Name',
  MODULE_SECURE: 'Module Secure',
  MODULE_ACCESS_GROUP: 'Module Access Group',
  PAGE_PATH: 'Page Path',
  PAGE_OWNER_ID: 'Page Owner ID',
  PAGE_TITLE: 'Page Title',
  PUBLIC_VIEW: 'Public View',
  CONTEXT_KEY_NAME: 'Context Key Name',
  QUICK_LINK_TITLE: 'Quick Link Title',
  QUICK_LINK_TYPE: 'Quick Link Type',
  QUICK_LINK_URL: 'Quick Link URL',
  EXPORTED_MODULE_PAGES: 'Exported Module Pages',
  EXPORTED_PAGES: 'Exported Page Paths',
  EXPORTED_MODULE_TOCS: 'Exported Module TOCs',
  RESTORE_ARCHIVED_PAGE: 'Restored Archived Pages',
  DELETE_UGC_PAGE: 'Deleted UGC Page Paths',
  PUBLISH_ID: 'Publish ID',
  PUBLISH_SUMMARY: 'Publish Summary',
  PUBLISH_TYPE: 'Publish Type',
  PUBLISH_AT: 'Published At'
};

export const MIXPANEL_TRACE_STRING = {
  USER_ROLE_VIEW: {
    ADMIN: 'Admin Mode',
    CLIENT: 'Client Mode'
  }
};

export const MIXPANEL_TRACE_EVENT = {
  LOG_IN: 'Login',
  PENDING_UPDATES: 'Pending Updates',
  ACCEPTED_UPDATES: 'Accepted Updates',
  LOADING_PAGE: 'Page Load',
  PAGE_VISIBILITY_ON: 'Page Visibility ON',
  PAGE_VISIBILITY_OFF: 'Page Visibility OFF',
  CONTEXT_KEY_VALUE_UPDATE: 'Context Key Value Update',
  UGC_MODULE_CREATION: 'UGC Module Creation',
  UGC_MODULE_UPDATE: 'UGC Module Update',
  CS_MODULE_UPDATE: 'CompliSpace Module Update',
  UGC_PAGE_CREATION: 'UGC Page Creation',
  UGC_PAGE_UPDATE: 'UGC Page Update',
  UGC_PAGE_DELETION: 'UGC Page Deletion',
  QUICK_LINK_VIEW: 'Quick Link View',
  QUICK_LINK_CREATION: 'Quick Link Creation',
  EXPORT_SELECTION_OF_PAGES: 'Export Selection of Pages',
  EXPORT_MODULE: 'Export Module',
  EXPORT_PAGE: 'Export Page',
  EXPORT_MODULE_TOC: 'Export Module TOC',
  EXPORT_TOC: 'Export TOC',
  ARCHIVE_UGC_PAGE: 'Archive UGC Page',
  RESTORE_ARCHIVED_PAGE: 'Restore Archived Page',
  DELETE_UGC_PAGE: 'Delete UGC Page'
};

export const FEATURE_NAMES = {
  SECURE_UGC_MODULE: 'policy-secure-ugc-module'
};

export const MODULE_ADMIN_TYPE = {
  TYPE_ORDERING: 'Ordering Module',
  TYPE_EXPORT: 'Exporting Module'
};

export const PUBLISH_OPTIONS = {
  PARENT_SITE_ONLY: 'parent-site-only',
  PARENT_SITE_AND_CHILD_SITES: 'parent-site-and-child-sites',
  ALL_SITES: 'all-sites'
};

export const ITEM_PER_PAGE_OPTIONS_FROM_15 = [
  { value: 15, title: '15' },
  { value: 25, title: '25' },
  { value: 50, title: '50' },
  { value: 100, title: '100' }
];

export const ITEM_PER_PAGE_OPTIONS_FROM_5 = [
  { value: 5, title: '5' },
  { value: 10, title: '10' },
  { value: 15, title: '15' },
  { value: -1, title: '$vuetify.dataFooter.itemsPerPageAll' }
];

export function mapAuditEventsItemAffected(event, detail, action) {
  const formattedEvent = event.toUpperCase().trim().replace(/\s+/g, '_');

  switch (formattedEvent) {
    case 'CLIENT_MODULE':
      if (
        (action === 'SET_PAGE_VISIBILITY_OFF' || action === 'SET_PAGE_VISIBILITY_ON') &&
        Object.prototype.hasOwnProperty.call(detail, 'pageTitle')
      ) {
        return detail.moduleName.concat('/').concat(detail.pageTitle);
      }
      return detail.moduleName ? detail.moduleName : '';

    case 'CLIENT_CONTEXT':
      return detail.clientContextKey ? detail.clientContextKey : '';
    case 'CLIENT_APP':
      return detail.appName ? detail.appName : '';
    case 'APP_MODULE':
      return detail.moduleName ? detail.moduleName : '';
    case 'MODULE':
      return detail.moduleName ? detail.moduleName : '';
    case 'CLIENT_APP_MODULE':
      return detail.moduleName ? detail.moduleName : '';
    case 'CLIENT_PAGE':
      if (detail.moduleName && detail.pageTitle) {
        return detail.moduleName.concat('/').concat(detail.pageTitle);
      }
      if (detail.moduleName) {
        return detail.moduleName;
      }
      if (detail.pageTitle) {
        return detail.pageTitle;
      }
      return '';
    default:
      return '';
  }
}

export function exportPageHTML(
  documentDate,
  moduleLastUpdated,
  filename,
  logoUri,
  innerHTML,
  _options = { includeHeader: true, includeFooter: true }
) {
  return `
              <html>
              <meta http-equiv="Content-Type" content="text/html; charset=utf-8">
              <link href='${PDF_EXPORT_FONT_HREF}' rel="stylesheet">
              <style>
${READABLE_CONTENT_CSS}
              </style>
              <title>${filename}</title>
              </head>
              <body class="readable-content">
              ${
                _options.includeHeader
                  ? `<div class="divHeader">This document was current as at ${documentDate} AEST time. Updates to content may have been made since this date. Refer to your policy site for the latest version.<br></div>`
                  : ``
              } 
                  <table class="page-table">
                      <thead>
                          <tr>
                              <td>
                                  <div class="header-space">&nbsp;</div>
                              </td>
                          </tr>
                      </thead>
                      <tbody>
                          <tr>
                              <td>
                                  <div>
                                      <img class="logo-top" src="${logoUri}" alt="Logo"/>
                                  </div>
                                  <div>${innerHTML}</div>
                              </td>
                          </tr>
                      </tbody>
                      <tfoot>
                          <tr>
                              <td>
                                  <div class="footer-space">&nbsp;</div>
                              </td>
                          </tr>
                      </tfoot>
                  </table>
                  ${
                    // eslint-disable-next-line no-nested-ternary
                    _options.includeFooter
                      ? moduleLastUpdated === documentDate
                        ? `<div class="divFooter"><br>This document was current as at ${documentDate} AEST time. Updates to content may have been made since this date. Refer to your policy site for the latest version.</div>`
                        : `<div class="divFooter"><br>This content was last updated on ${moduleLastUpdated} AEST time.</div>`
                      : ``
                  }
                  </body>
              </html>
          `;
}
